import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import { PATH_DASHBOARD } from './paths';
import AuthGuard from '../guards/AuthGuard';
import DashboardLayout from '../layouts/dashboard';

// ----------------------------------------------------------------------

const DashboardRoutes = {
  path: PATH_DASHBOARD.root,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------
    // {
    //   exact: true,
    //   path: PATH_DASHBOARD.general.home,
    //   // component: lazy(() => import('../views/GeneralApp'))
    //   component: lazy(() => import('../views/BrightIQ/home'))
    // },
    /* {
      exact: true,
      path: PATH_DASHBOARD.general.app,
      component: lazy(() => import('../views/GeneralApp'))
    }, */
    {
      exact: true,
      path: PATH_DASHBOARD.general.alarm,
      component: lazy(() => import('../views/BrightIQ/alarm-warning'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.entityCount,
      component: lazy(() => import('../views/BrightIQ/entity-count'))
    },
    /* {
      exact: true,
      path: PATH_DASHBOARD.general.integration,
      component: lazy(() => import('../views/BrightIQ/integration'))
    }, */
    {
      exact: true,
      path: PATH_DASHBOARD.general.locations,
      component: lazy(() => import('../views/BrightIQ/locations'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.faceSearch,
      component: lazy(() => import('../views/BrightIQ/face-search'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.addEmployee,
      component: lazy(() => import('../views/BrightIQ/add-employee'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.addZone,
      component: lazy(() => import('../views/BrightIQ/add-zone'))
    },
    /* {
      exact: true,
      path: PATH_DASHBOARD.general.generalAnalysis,
      component: lazy(() => import('../views/BrightIQ/general-analysis'))
    }, */
    /* {
      exact: true,
      path: PATH_DASHBOARD.general.employeeDetail,
      component: lazy(() => import('../views/BrightIQ/employee-detail'))
    }, */

    {
      exact: true,
      path: PATH_DASHBOARD.general.employeeProductivityDetail,
      component: lazy(() => import('../views/BrightIQ/employee-productivity-detail'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.zoneProductivityDetail,
      component: lazy(() => import('../views/BrightIQ/zone-productivity-detail'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.fireFighter,
      component: lazy(() => import('../views/BrightIQ/fire-fighter'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.supervisor,
      component: lazy(() => import('../views/BrightIQ/supervisor'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.alarmSupervisor,
      component: lazy(() => import('../views/BrightIQ/alarm-warning-supervisor'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.companiesFireFighter,
      component: lazy(() => import('../views/BrightIQ/companies-fire-fighter'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.companies,
      component: lazy(() => import('../views/BrightIQ/companies'))
    },

    {
      exact: true,
      path: PATH_DASHBOARD.general.profile,
      component: lazy(() => import('../views/BrightIQ/profile'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.management,
      component: lazy(() => import('../views/BrightIQ/management'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.settings,
      component: lazy(() => import('../views/BrightIQ/settings'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.alarmDetail,
      component: lazy(() => import('../views/BrightIQ/alarm-detail'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.general.connectivity,
      component: lazy(() => import('../views/BrightIQ/connectivity'))
    },

    {
      exact: true,
      path: PATH_DASHBOARD.general.accuracyCheck,
      component: lazy(() => import('../views/BrightIQ/accuracy-check'))
    },

    {
      exact: true,
      path: PATH_DASHBOARD.general.accuracyImprover,
      component: lazy(() => import('../views/BrightIQ/accuracy-improver'))
    },
    {
      exact: true,
      path: PATH_DASHBOARD.root,
      component: () => <Redirect to={PATH_DASHBOARD.general.alarm} />
    },

    // ----------------------------------------------------------------------

    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default DashboardRoutes;
